import { Inject, Injectable, inject } from '@angular/core';
import { UserAccessableHotelsEndpointService } from '../api/services';
import { HotelInfo } from '../api/models';
import { SESSION_STORAGE } from '@donstudio/ds/_tokens';
import { AuthService } from '@modules/auth';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiHotelService {
  private readonly hotelsUserService = inject(UserAccessableHotelsEndpointService);
  private userHotelsList$$: Subject<HotelInfo[]> = new Subject();
  userHotelsList$: Observable<HotelInfo[]>;

  userHotelsList: HotelInfo[] = [];
  isPdfRequest: boolean = false;

  constructor(
    @Inject(SESSION_STORAGE) private sessionStorage: Storage,
  ) {
    this.userHotelsList$ = this.userHotelsList$$.asObservable();
  }

  getHotelsUser() {
    this.hotelsUserService.apiHotelListGet().subscribe({
      next: it => {
        if (it.isSuccess && it.data?.length) {
          this.userHotelsList$$.next([...it.data])
          this.sessionStorage.setItem('hotel', JSON.stringify(it.data[0]));
          return;
        }
      },
      error: (err) => {
        console.error('error :>> ', err);
      }
    })
  }


}
